import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ReceiptCaptureCard } from "../components/ReceiptCaptureCard";
import { readPendingReceiptJobSnapshot } from "../lib/receipt";
import { UI_TEXT_TONE } from "../lib/uiTone";

type ReceiptRouteState = {
  returnTo?: string;
  conversationId?: string;
  messageId?: string;
};

export default function ReceiptPopup() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (typeof location.state === "object" && location.state ? location.state : {}) as ReceiptRouteState;
  const pendingSnapshot = readPendingReceiptJobSnapshot();

  const returnTo = state.returnTo || pendingSnapshot?.returnTo || "/chat";

  const closePopup = () => {
    navigate(returnTo, { replace: true });
  };

  return (
    <main className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(250,233,220,0.95),_rgba(255,249,245,1)_55%)] px-4 py-6 text-[#4A3E39] sm:px-6 sm:py-10">
      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-xl items-center justify-center">
        <div className="relative w-full max-w-full rounded-[2.4rem] border border-white/80 bg-white/90 p-4 shadow-[0_24px_60px_rgba(124,90,78,0.16)] backdrop-blur-sm sm:p-7">
          <button
            type="button"
            onClick={closePopup}
            aria-label="閉じる"
            className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#EADBC8] bg-[#FFF8F4] text-[#7C5A4E] transition hover:bg-white"
          >
            ×
          </button>

          <div className="mb-5 pr-12">
            <h1 className={`text-2xl font-black tracking-tight ${UI_TEXT_TONE.title}`}>領収書を保存する</h1>
            <p className={`mt-2 text-sm leading-6 ${UI_TEXT_TONE.body}`}>
              たまりがちな領収書をまとめて整理し、あとから見返しやすく管理するための画面です。
            </p>
          </div>

          <ReceiptCaptureCard
            returnTo={returnTo}
            conversationId={state.conversationId}
            messageId={state.messageId}
            onClose={closePopup}
          />
        </div>
      </div>
    </main>
  );
}
